import { render, staticRenderFns } from "./LegacyView.vue?vue&type=template&id=61600dc4"
import script from "./LegacyView.vue?vue&type=script&lang=js"
export * from "./LegacyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports